import android from '../svgs/android.svg';
import truck from '../svgs/caminhao.svg';
import disney from '../svgs/disney.svg';
import star from '../svgs/estrela.svg';
import gas from '../svgs/gasolina.svg';
import bike from '../svgs/moto.svg';

export const items = [
    { name: 'android', icon: android },
    { name: 'caminhao', icon: truck },
    { name: 'disney', icon: disney },
    { name: 'estrela', icon: star },
    { name: 'gasolina', icon: gas },
    { name: 'moto', icon: bike },

];